import { render, staticRenderFns } from "./ShareIcon.vue?vue&type=template&id=8c74351e&scoped=true&"
import script from "./ShareIcon.vue?vue&type=script&lang=js&"
export * from "./ShareIcon.vue?vue&type=script&lang=js&"
import style0 from "./ShareIcon.vue?vue&type=style&index=0&id=8c74351e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c74351e",
  null
  
)

export default component.exports